import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "./Sidebar";
import { hasAnyPermission } from "../utils/permissions";

const PrivateRoute = ({ component: Component, authenticated, permissions, requirePermissions, ...rest }) => {
  const [collapsed, setCollapsed] = React.useState(true);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authenticated) {
          return <Redirect to="/login" />;
        }
        // If specific permissions are required and user has none of them, redirect appropriately
        if (requirePermissions && !hasAnyPermission(permissions, requirePermissions)) {
          return <Redirect to="/" />;
        }
        return (
          <div style={{ display: "flex", minHeight: "100vh" }}>
            <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
            <div
              className="main-content"
              style={{
                flex: 1,
                minWidth: 0,
                marginLeft: collapsed ? 50 : 220,
                transition: "margin-left 0.2s",
              }}
            >
              <Component {...props} />
            </div>
          </div>
        );
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  authenticated: state.authenticated,
  permissions: state.permissions,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
